import App from './App'
import InFrameComm from './data/InFrameComm'

window.careem = {
  exports: {
    InFrameComm: InFrameComm,
    App: App
  }
}